import { Shield } from "lucide-react";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();

  // Check if we're in the CEO/Founder context for orange theming
  const isFounderContext =
    location.pathname.startsWith("/for-founders") || location.pathname.startsWith("/ceo/sample-report");

  return (
    <footer className="border-t border-border bg-card/30 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div
                className={`flex h-9 w-9 items-center justify-center rounded-lg ${
                  isFounderContext ? "bg-gradient-to-br from-amber-500 to-orange-500" : "bg-primary"
                }`}
              >
                <Shield className="h-5 w-5 text-white" />
              </div>
              <span className="font-display text-xl font-bold tracking-tight">PROVENANCE</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              {isFounderContext
                ? "Independent technology health checks for founders and CEOs. Know the truth about your codebase."
                : "Expert-led technology due diligence for M&A transactions. We help investors uncover the truth behind the code."}
            </p>
            <div className="mt-6 space-y-2 text-sm text-muted-foreground">
              <p className="flex items-center gap-2">
                <span className="font-medium text-foreground">Email:</span>
                <a href="mailto:hello@provenance360.com" className="hover:text-foreground transition-colors">
                  hello@provenance360.com
                </a>
              </p>
              <p className="text-muted-foreground/80">London, United Kingdom</p>
            </div>
          </div>

          {/* Services - Context-aware */}
          <div>
            <h4 className="font-display font-semibold mb-4">Services</h4>
            {isFounderContext ? (
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <a href="/for-founders#solution" className="hover:text-foreground transition-colors">
                    Technology health checks
                  </a>
                </li>
                <li>
                  <a href="/for-founders#how-it-works" className="hover:text-foreground transition-colors">
                    How it works
                  </a>
                </li>
                <li>
                  <a href="/for-founders#pricing" className="hover:text-foreground transition-colors">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="/ceo/sample-report" className="hover:text-foreground transition-colors">
                    Sample report
                  </a>
                </li>
              </ul>
            ) : (
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <a href="/#services" className="hover:text-foreground transition-colors">
                    Technology due diligence
                  </a>
                </li>
                <li>
                  <a href="/#how-it-works" className="hover:text-foreground transition-colors">
                    Our approach
                  </a>
                </li>
                <li>
                  <a href="/#pillars" className="hover:text-foreground transition-colors">
                    Assessment framework
                  </a>
                </li>
                <li>
                  <a href="/demo" className="hover:text-foreground transition-colors">
                    Platform demo
                  </a>
                </li>
              </ul>
            )}
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/about" className="hover:text-foreground transition-colors">
                  About us
                </a>
              </li>
              <li>
                <a href="/team" className="hover:text-foreground transition-colors">
                  Our team
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-foreground transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-foreground transition-colors">
                  Privacy policy
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-foreground transition-colors">
                  Terms of service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">© 2026 Provenance. All rights reserved.</p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <span className="h-2 w-2 rounded-full bg-score-excellent animate-pulse" />
              SOC2 Type II
            </span>
            <span className="flex items-center gap-1">
              <span className="h-2 w-2 rounded-full bg-score-excellent animate-pulse" />
              ISO 27001
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
